import ButtonPressed from '../assets/audio/ButtonPressed.mp3';
import CoinGain from '../assets/audio/CoinGain.mp3';
import LevelUp from '../assets/audio/LevelUp.mp3';
import MessageRecieved from '../assets/audio/MessageRecieved.mp3';
import Notification from '../assets/audio/Notification.mp3';
import ToastError from '../assets/audio/ToastError.mp3';
import ToggleSound from '../assets/audio/ToggleSound.mp3';
import LS from './localStorageUtils';

// Keep in sync with sound.d.ts (the platform-neutral contract) and sound.native.ts.
const sources = {
	ButtonPressed,
	ToggleSound,
	ToastError,
	Notification,
	CoinGain,
	LevelUp,
	MessageRecieved,
} as const;

export type SoundName = keyof typeof sources;

export type PlaySoundOptions = { force?: boolean };

const isSoundEnabled = () => {
	const rawUser = LS.get('auth_user');
	if (!rawUser) return true;

	try {
		const user = JSON.parse(rawUser) as { isSoundEffectsEnabled?: boolean };
		return user.isSoundEffectsEnabled !== false;
	} catch {
		return true;
	}
};

// One element per effect, kept and restarted, instead of a new Audio() per play:
// the click now fires on every button and the browser would otherwise re-fetch
// and re-decode the file each time.
const players = new Map<SoundName, HTMLAudioElement>();

const get = (name: SoundName): HTMLAudioElement | null => {
	if (typeof Audio === 'undefined') return null; // SSR / test environments
	let audio = players.get(name);
	if (!audio) {
		audio = new Audio(sources[name]);
		audio.preload = 'auto';
		players.set(name, audio);
	}
	return audio;
};

export const playSound = (name: SoundName, options?: PlaySoundOptions) => {
	if (!options?.force && !isSoundEnabled()) return;

	try {
		const audio = get(name);
		if (!audio) return;
		audio.currentTime = 0;
		// Rejected until the first user gesture (autoplay policy); sound is decoration.
		audio.play().catch(() => {});
	} catch {
		// never let a missing/blocked sound surface as an error
	}
};
